// extracted by mini-css-extract-plugin
export default {"gradientFill":"zBSNLG"};